import { put } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";

export function* updateSelectedLanguage(action) {
	yield put({
		type: actionTypes.UPDATE_LANGUAGE,
		payload: action.payload,
	});
}
